import React, { useRef } from "react"
import Row from "antd/lib/row"
import Collapse from "antd/lib/collapse"
import FormInputDate from "./formInputDate"
import { FormMinMaxBaseInterface } from "./form.types"

export default function FormMinMaxDate({ header, min, max, keyCode = "0", extra = <></> }: FormMinMaxBaseInterface) {
    const anchorRef = useRef(null)

    return (
        <>
            {/* empty div to fix ant-design bug for non-sticky dropdowns */}
            <div ref={anchorRef} />
            <Collapse ghost defaultActiveKey={keyCode}>
                <Collapse.Panel header={header} key={keyCode} extra={extra}>
                    <Row gutter={[16, 16]}>
                        <FormInputDate elem={min} anchorRef={anchorRef} />
                        <FormInputDate elem={max} anchorRef={anchorRef} />
                    </Row>
                </Collapse.Panel>
            </Collapse>
        </>
    )
}
